import React from 'react'
import SearchResultFragment from "../Search/SearchResultFragment";

export default function SearchResult(props){

    const res = props.data;

    return res.fragments.map((fragment, i) => {
        if (fragment.video_url) {
            return <SearchResultFragment key={'search_result_fragment_'+i} data={res} fragment={fragment}></SearchResultFragment>
        }
        return '';
    });
}
